module.exports = __webpack_public_path__ + "img/nut.0faf7ce7.svg";